/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import LoaderCircle from "./components/inc/loader/LoaderCircle";
import SpotSearchFilter from "./components/global/SpotSearchFilter";
import PurchaseOrderItemList from "./components/purchase-orders/PurchaseOrderItemList";
import Intouch from './components/intouch/Intouch';
import IntouchEdit from './components/intouch/IntouchEdit';
import AAU from './components/aau/AAU';
import PurchaseOrderForm from "./components/purchase-orders/PurchaseOrderForm";
import PurchaseOrderEditForm from "./components/purchase-orders/Edit/PurchaseOrderEditForm";
import DeliveryChallanModal from "./components/delivery-challan/DeliveryChallanModal";
import DeliveryChallanList from "./components/delivery-challan/DeliveryChallanList";
import DeliveryChallanItems from "./components/delivery-challan-items/DeliveryChallanItems";
import DeliveryChallanEditItem from "./components/delivery-challan-items/Edit/DeliveryChallanEditItem";
import TimelineHistoryTrackerPO from "./components/purchase-orders/TimelineHistoryTrackerPO";
import InspectionForm from "./components/inspection/InspectionForm";
import DashboardTicket from "./components/dashboards/DashboardTicket";
import InitialModalORWService from "./components/outreachworker/InitialModalORWService";
import FullMap from "./components/dashboards/map/FullMap";
import PositiveMap from "./components/dashboards/map/PositiveMap";
import ComponentIndicators from "./components/dashboards/map/ComponentIndicators";
import CityWiseRegistration from "./components/dashboards/charts/CityWiseRegistration";
import CityWiseARTRegistered from "./components/dashboards/charts/CityWiseARTRegistered";
import CityWiseReactive from "./components/dashboards/charts/CityWiseReactive";
import CityWiseVcctTested from "./components/dashboards/charts/CityWiseVcctTested";
import CityWiseGender from "./components/dashboards/charts/CityWiseGender";
import ProvincesMap from './components/dashboards/map/ProvincesMap';
import KpkMap from './components/dashboards/map/KPKMap'
import PunjabMap from './components/dashboards/map/PunjabMap'
import SindhMap from './components/dashboards/map/SindhMap'
import SindhMapOverall from './components/dashboards/map/SindhMapOverall'
import BalochistanMap from './components/dashboards/map/BalochistanMap'
import SiteHomePage from './components/dashboards/site/SiteHomePage'

import OutReachWorkerIndex from './components/outreachworker/Index';
import PreventionCounselingIndex from './components/prevention-counseling/Index';

import HrEmployeeIndex from './components/hr/Index';
import HrEmployeeEducation from './components/hr/Education';

/**
 * Warehouse components
 */
 import InventoryRequestForm from "./components/warehouse/inventory-request/InventoryRequestForm";
 import InventoryRequestEditForm from "./components/warehouse/inventory-request/Edit/InventoryRequestEditForm.vue";
// Waybill
import WaybillItems from "./components/warehouse/waybills/WaybillItems.vue";
import WaybillItemsEdit from "./components/warehouse/waybills/edit/WaybillItemsEdit.vue";


require('./bootstrap');

window.Vue = require('vue');
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
window.Vue.use(VueFilterDateFormat);
window.axios = require('axios')

// setting csrf token
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};
// setting default base url
var baseUrl
var ajaxUrl
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css'
Vue.use(require('advanced-laravel-vue-paginate'));
var currentUrl = window.location.href;
if (currentUrl.includes('public')){
    axios.defaults.baseURL = 'http://localhost/NaiZindagiMIS/public/ajax/';
}
else if (currentUrl.includes(8000)){
    axios.defaults.baseURL = 'http://127.0.0.1:8000/ajax/';
} else {
    axios.defaults.baseURL = '/ajax/';
}

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
//Vue.component('state-component', require('./components/global/StateComponent').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var app = new Vue({
    el: '#app',
    components: {
        'loader-circle' : LoaderCircle,
        'spot-search-filter' : SpotSearchFilter,
        'purchase-order-item-list': PurchaseOrderItemList,
        'intouch' : Intouch,
        'intouch-edit' : IntouchEdit,
        'aau' : AAU,
        'purchase-order-form' : PurchaseOrderForm,
        'purchase-order-edit-form' : PurchaseOrderEditForm,
        'delivery-challan-modal': DeliveryChallanModal,
        'delivery-challan-list' : DeliveryChallanList,
        'delivery-challan-items' : DeliveryChallanItems,
        'delevery-challan-edit-item' : DeliveryChallanEditItem,
        'timeline-history-tracker-po' : TimelineHistoryTrackerPO,
        'inspection-form' : InspectionForm,
        'initial-modal-orw-service' : InitialModalORWService,
        'dashboard-ticket' : DashboardTicket,
        'full-map' : FullMap,
        'positive-map' : PositiveMap,
        'component-indicators' : ComponentIndicators,
        'city-wise-registration' : CityWiseRegistration,
        'city-wise-art-registered' : CityWiseARTRegistered,
        'city-wise-reactive' : CityWiseReactive,
        'city-wise-vcct-tested' : CityWiseVcctTested,
        'city-wise-gender' : CityWiseGender,
        'provinces-map' : ProvincesMap,
        'out-reach-worker-index' : OutReachWorkerIndex,
        'prevention-counseling-index' : PreventionCounselingIndex,
        'kpk-map' : KpkMap,
        'punjab-map' : PunjabMap,
        'balochistan-map' : BalochistanMap,
        'sindh-map' : SindhMap,
        'sindh-map-overall' : SindhMapOverall,
        'site-home-page' : SiteHomePage,
        'hr-employee-index' : HrEmployeeIndex,
        'hr-employee-education' : HrEmployeeEducation,
        'inventory-request-form' : InventoryRequestForm,
        'inventory-request-edit-form' : InventoryRequestEditForm,
        'waybill-items' : WaybillItems,
        'waybill-items-edit' : WaybillItemsEdit,
    },
    data:{
            base_url : "http://localhost/NaiZindagiMIS/ajax/",
            org_id: "",
            reg_nos: null,
            state_id: "",
            area_id: "",
            cities: null,
            states: null,
            areas: null,
            spots: null,
            errored: false,
            loading: false,
            city_id: null,
            spot_id: null,
            country_id: null,
            country: null,
            organization_id: null,
            ReferredBy: null,
            ReferredBySpecify: "",
            Nationality: "Pakistani",
            NationalitySpecify: "",
            ProfessionalSkills: "",
            ProfessionalSkillsSpecify: "",
            SourceOfIncome: "",
            SourceOfIncomeSpecify: "",
            NormallyUseDrugs: "",
            NormallyUseDrugsSpecify: "",
            LiveOnStreetsAtNight: "",
            PresentlyLivingWith: "",
            PresentlyLivingWithSpecify: "",
            TypeOfDrugFirstTime: "",
            TypeOfDrugFirstTimeSpecify: "",
            PresentDrugMostlyBeingUsed: "",
            PresentDrugMostlyBeingUsedSpecify: "",
            HowDoYouMostlyUseThisDrug: "",
            HowDoYouMostlyUseThisDrugSpecify: "",
            EverInjectctedDrugs: "",
            DrugInjectedLast3Months: "",
            WhyDidYouStopInjecting: "",
            DrugsInjected1: "",
            DrugsInjected2: "",
            DrugsInjected3: "",
            DrugsInjected4: "",
            ReasonToInitiateInjecting: "",
            ReasonToInitiateInjectingSpecify: "",
            SyringAcquiredFrom: "",
            SyringAcquiredFromSpecify: "",
            EverInjectedByStreetDoctor: "",
            EverInjectedByStreetDoctorMonthsBack: "",
            JailedForDrugUsage: "",
            JailedForDrugUsageMonthsBack: "",
            SeeWhenIll: "",
            SeeWhenIllSpecify: "",
            Diseases: "",
            Diseases1: "",
            Diseases2: "",
            DonatedSellBlood: "",
            DonatedSellBloodMonthBack: "",
            DonatedSellBloodWhy: "",
            DonateBloodTime: "",
            SexualRelationWithAnyOne: "",
            SexualRelationWithWhom: "",
            SexualRelationWithWhomSpecify: "",
            LastIntercourseWithWhom: "",
            LastIntercourseWithWhomSpecify: "",
            HeardAboutCondom: "",
            UsedCondom: "",
            TreatedForSTI: "",
            TreatedForSTISymptoms1: "",
            TreatedForSTISymptoms2: "",
            TreatedForSTISymptoms3: "",
            InformationSource1: "",
            InformationSource2: "",
            SyringeUsedBy: "",

            // For VCCT (Others)
            ReasonForRegistration: "",
            ReasonForRegistrationSpecify: "",
            Category : "",

            LastSexualIntercourse: "",

            // Add LSP to Spouse
            Alive: "1",
            MaritalStatus: "",
            LivingWithYes: "",
            LivingWithNo: "",
            SpouseLiving: "",
            SpouseLivingSpecify: "",
            ResidenceSpecify : "",
            Residence: "",
            FamilyStructre: "",
            Expenditure: "",
            Income: "",
            SourceOfIncomeLSP: "",
            SourceOfIncomeSpecifyLSP: "",
            OtherWhoContribute: "",
            OtherContributionHowmuch: "",
            IncomeStatus: "",
            MonetarySupport: "",
            IncomeStatusSpecify: "",
            MonetarySupportDetail: "",

            // InTouch
            CallStatus: "",
            Status: "",
            Recovery: "",
            Issues: "",

            // Risk Assessment
            AcquireSyringeSpecify    : "",
            PersonULookedAfterSpecify    : "",

    },
    methods: {
        callStatesByCountryId(){
            axios.get('states/' + this.country_id)
                .then(response => {
                    this.states = response.data
                }).
            catch(error => {
                console.log(error)
                this.errored = true
            })
                .finally(() => this.loading = false)
        },
        callCitiesByStateID(){
            axios.get('cities/' + this.state_id)
                .then(response => {
                    this.cities = response.data
                    console.log(this.cities);
                }).
            catch(error => {
                console.log(error)
                this.errored = true
            })
                .finally(() => this.loading = false)
        },
        callAreaByCityID(city_id){
            axios.get('areas/' + city_id)
                .then(response => {
                    this.areas = response.data
                    console.log(this.areas);
                }).
            catch(error => {
                console.log(error)
                this.errored = true
            })
                .finally(() => this.loading = false)
        },
        callSpotByAreaID(area_id){
            axios.get( 'spots/' + area_id)
                .then(response => {
                    this.spots = response.data
                }).
            catch(error => {
                console.log(error)
                this.errored = true
            })
                .finally(() => this.loading = false)
        },
        callCitiesByOrgID(org_id){
            axios.get('org-cities/' + org_id)
                .then(response => {
                    this.cities = response.data
                    console.log(this.cities);
                }).
            catch(error => {
                console.log(error)
                this.errored = true
            })
                .finally(() => this.loading = false)
        },
        callRegNoByCityID(city_id){
            axios.get('city-regnos/' + city_id)
                .then(response => {
                    this.reg_nos = response.data
                }).
            catch(error => {
                this.errored = true
            })
                .finally(() => this.loading = false)
        },
        submitForm: function(e){
            console.log(e.data);
            var form = document.getElementById('lsp_form')
            var formData = new FormData($('#lsp_form')[0]);
            console.log(formData)
            axios.post('http://localhost/NaiZindagiMIS/spouses/lsp', {
                formData
            }).then(function (response) {
                console.log(response.data);
            })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
});
window.app = app;
